/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Max_Planck_Schule3Inputs */

const en__field_enum_max_planck_schule3 = /** @type {(inputs: _Field_Enum_Max_Planck_Schule3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rüsselsheim`)
};

const de__field_enum_max_planck_schule3 = /** @type {(inputs: _Field_Enum_Max_Planck_Schule3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Max-Planck-Schule`)
};

/**
* | output |
* | --- |
* | "Rüsselsheim" |
*
* @param {_Field_Enum_Max_Planck_Schule3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_max_planck_schule3 = /** @type {((inputs?: _Field_Enum_Max_Planck_Schule3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Max_Planck_Schule3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_max_planck_schule3(inputs)
	return de__field_enum_max_planck_schule3(inputs)
});
export { _field_enum_max_planck_schule3 as "_field_enum_Max_Planck_Schule" }